module.exports = __webpack_public_path__ + "img/ccx-2026.487eb09f.jpg";